import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutProspectActivityLookup extends Layout {
    sourceProspectActivity: DataSource;
    tableProspectActicity: Table;
}
